store = window.store || {};
store.admin = store.admin || {};

store.admin.init = function() {
	store.admin.initFocusFirst();
	store.admin.initUnloadWarning();

};
store.admin.submitting = false;
store.admin.addInitialValue = function() {
	var d = store.admin.elementGetStringVal(this);
	$(this).data('initialValue', d);
};
store.admin.initUnloadWarning = function() {
	var $s = $('#store');
	$s.find('.boxText .store_form :input').each(store.admin.addInitialValue);
	$(window).bind('beforeunload', function(){
		if(!store.admin.submitting){
			var msg = '';
			var current = '';
			var initial = '';

			$('#store').find('.boxText .store_form :input').each(function () {
				current = store.admin.elementGetStringVal(this);
				initial = $(this).data('initialValue');

				// Make sure "" == 0
				current = (!current) ? "0" : current;
				initial = (!initial) ? "0" : initial;

				if (initial != current){
					msg = store.t.__('formDirty');
					//console.log(this.id, current, initial);
					return false;
				}
			});

			if(msg) {
				return msg;
			}
		}
	});
	$s.find('input.submit').click(function(){
		// Dont want to warn user when submitting
		store.admin.submitting = true;
	});
};
/**
 * Only focus for add not edit. Focus does selectAll on input. Possibility of accidental changes.
 */
store.admin.initFocusFirst = function() {
	$('#store').find('.boxText :input:enabled').each(function(){
		var t = $(this);
		var val = t.val();
		if (!val || val == '0') {
			if (t.hasClass('lang')) {
				return true;
			}

			this.focus();
		}
		return false;
	});
};
